export type SolutionOmniverseSessionApp = {
  id: string;
  solutionId: string;
  siteId: string;
  functionId: string;
  functionVersionId: string;
  title: string;
  description: string;
  version: string;
  image: string;
  icon: string;
  category: string;
  productArea: string;
  authenticationType: string;
  mediaServer: string;
  mediaPort: number;
  status: string;
  twinId?: string;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
};

export type SolutionOmniverseSession = {
  id: string;
  functionId: string;
  functionVersionId: string;
  appId: string;
  app: SolutionOmniverseSessionApp;
  userId: string;
  userName: string;
  status: string;
  startDate: string;
  endDate: string;
  solutionId: string;
  siteId: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
};

export enum SolutionOmniverseSessionField {
  Id = 'id',
  FunctionId = 'functionId',
  FunctionVersionId = 'functionVersionId',
  AppId = 'appId',
  UserId = 'userId',
  UserName = 'userName',
  Status = 'status',
  StartDate = 'startDate',
  EndDate = 'endDate',
  SolutionId = 'solutionId',
  SiteId = 'siteId',
  CreatedBy = 'createdBy',
  UpdatedBy = 'updatedBy',
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt',
}
